<template>
  <div class="mixied-communicate">
    <div
      class="intention-communicate-item"
      v-for="(item) in logs"
      :key="item.id"
    >
      <div 
        class="circular-point"
        :class="{
          active: item.logType === 'activity',
          audition: item.logType === 'audition',
         }">
      </div>
      <div class="title">
        {{ app.tool.date.getPassTimeStr(item.createTime)}}
      </div>
      <div class="log-item">
        <div class="types-line">
          {{typesDesc[item.type]}}<span style="color:var(--g6);" v-if="item.operatorName">({{item.operatorName}})</span>
        </div>
        <div 
          class="log-content communicate-item" 
          v-if="item.type === 1" 
          @click="toDetailsCommunicateInfos(item.communicateDto)"
          >
          <div class="content-nav">
            <div class="content"  >
              <vx-mult-input-intro
                @click="toDetailsCommunicateInfos(item.communicateDto)"
                class="r"
                v-if="item.communicateDto &&  item.communicateDto.content.list"
                :list="item.communicateDto && item.communicateDto.content.list"
              />
              <van-popover

                class="communicate-popover"
                v-model="item.showPopover"
                trigger="click"
                placement="bottom-end"
                v-if="(app.permission.op(editPermissionStr) || app.permission.op(deletePermissionStr)) && clueInfos.status!==3"
                :offset="[22, 4]"
                :get-container="()=>$el"
              >
                <div 
                  @click.stop="gotoEditCommunicate(item && item.communicateDto)"
                  v-if="app.permission.op(editPermissionStr)"
                  class="communicate-popover popover-item">
                  编辑
                </div>
                <div 
                  class="communicate-popover popover-item"
                  @click.stop="deleteCommunication(item && item.communicateDto)"
                  v-if="app.permission.op(editPermissionStr)"
                  :class="{'van-hairline--top': true}"
                  style="color:var(--c3)">
                  删除
                </div>
                <template #reference>
                  <van-icon name="weapp-nav" class="operation-icon" @click.stop="$set(item,'showPopover',true)" />
                </template>
              </van-popover>
            </div>
            <div class="con" >
              <span 
                v-if=" item.communicateDto && item.communicateDto.typeDesc"
                class="tag primary" >
                {{ item.communicateDto && item.communicateDto.typeDesc }}
              </span>
              <span 
                v-if="item.communicateDto && item.communicateDto.mode"
                class="tag primary" >
                {{ item.communicateDto && item.communicateDto.mode }}
              </span>
            </div>
          </div>
        </div>
        <div class="log-content audition-item" v-if="item.type === 2">
          <div class="line">
            <div class="label">
              试听课：
            </div>
            <div class="content">
              <span v-if="item.auditionVo && item.auditionVo.coursePlanType === 1" style="padding-right: calc(var(--gap) * 4);">
                {{ item.auditionVo && item.auditionVo.curriculumName }}
              </span> 
              <span v-else style="padding-right: calc(var(--gap) * 4);">{{ item.auditionVo && item.auditionVo.className }}</span>
              <span 
                class="tag primary" 
                v-if="item.auditionVo 
                  && item.auditionVo.status>=0 
                  && auditionStatusDesc[item.auditionVo.status]" >{{auditionStatusDesc[item.auditionVo.status]}}</span>
            </div>
          </div>

          <div class="line">
            <div class="label">
              时间：
            </div>
            <div class="content">
              <span>{{ item.auditionVo.startTime | formatDatetime("MM-dd") }}</span>
              <span>（{{item.auditionVo.startTime | getWeek}}）</span>
              <span>
                <span>{{ item.auditionVo.startTime | formatDatetime("hh:mm") }}～</span>
                <span>{{item.auditionVo.endTime | formatDatetime("hh:mm")}}</span> 
              </span>
            </div>
          </div>
          <div class="line">
            <div class="label">
              老师：
            </div>
            <div class="content">
              {{item.auditionVo && item.auditionVo.courseArrangeTeacherName}}
            </div>
          </div>          
          <div class="footer" @click="cancleAudition(item)" v-if="item.auditionVo.status === 0 && clueInfos.status!==3">
            取消试听
          </div>
        </div>
        <!--活动记录-->
        <div class="log-content audition-item" v-if="item.type === 7">
          <div class="line" style="margin-bottom:calc(var(--gap)*8)">
            <div class="content" style="display: flex;justify-content: space-between; ">
              <span style="padding-right: calc(var(--gap) * 4);color: var(--g8);">{{ item.activityDto && item.activityDto.activityName }}</span>
              <span style="flex-shrink: 0;">{{ item.activityDto && item.activityDto.activityStatus }}</span>
            </div>
          </div>
          <div class="line">
            <div class="label">
              活动类型：
            </div>
            <div class="content">
              {{ item.activityDto && item.activityDto.activityType }}
            </div>
          </div>
          <div class="line">
            <div class="label">
              活动来源：
            </div>
            <div class="content">
              {{ item.activityDto && item.activityDto.comeFromDesc }}
            </div>
          </div>
          <div class="line">
            <div class="label">
              意向课程：
            </div>
            <div class="content">
              {{ (item.activityDto && item.activityDto.content) || '-' }}
            </div>
          </div>
        </div>
      </div>
    </div>    
    <van-loading size="24px" vertical v-if="loading" type="spinner" style="margin: 24px 0;">加载中...</van-loading>
  </div>
</template>

<script>

export default {
  name: 'mixiedCommunicate',
  props: {
    logs: {
      type: Array,
      required: true,
    },
    clueInfos: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: true,
    },
    isRecycleBin: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      typesDesc: {
        1: '添加沟通记录',
        2: '安排试听',
        3: '转为有效',
        4: '标记转化失败',
        5: '移入回收站',
        6: '意向恢复',
        7: '参加活动',
        8: '意向转化',
        9: '取消转化',
      },
      auditionStatusDesc:{       
        0: '待试听',
        1: '已试听',
        2: '试听失败',
        3: '已取消',
      },

    }
  },
  computed: {
    addPermissionStr (){
      return 'all_intention_clue || my_intention_clue'
    },
    deletePermissionStr (){
      return  'all_intention_clue || my_intention_clue' 
    },
    editPermissionStr (){
      return  'all_intention_clue || my_intention_clue' 
    },
  },
  methods: {
    toCall (item) {
      this.$emit('call', {...item});
    }, 
    toDetailsCommunicateInfos(item) {
      let path = '/communicationDetails?';
      path += `detailId=${item.id}`
      path += `&fromPage=clue` 
      if (this.clueInfos.status===3){
        path += `&hideOptBtns=true`
      }  
      this.$router.push(path);
    },
    gotoEditCommunicate(item) {
      let {id: clueId} = this.clueInfos;
      item.showPopover = false;
      if (app.permission.op(this.editPermissionStr)) {
        let path = '/clueAddCommunication?';
        path += `clueId=${clueId}&`;
        path += `detailId=${item.id}`
     
        this.$router.push(path);
      }
    },
    deleteCommunication(item) {
      item.showPopover = false;
      this.$dialog
        .confirm({
          message: "确定要删除此条沟通记录么？",
        })
        .then(() => {
          this.$api
            .deleteIntentionCommunicate({
              id: item.id,
            })
            .then((res) => {
              if (res.code === 200) {
                this.$toast.success("操作成功");
                app.vue.$emit("refresh-communicate-list");
              }
            });
        })
        .catch(() => {});
    },
    // 取消试听
    async cancleAudition (item = {}) {
      let {studentId, courseArrangeId, priceItemId, campusId} = item.auditionVo || {};
      
      try {
        let confirmRes = await this.$dialog.confirm({
            message: '是否确定取消学员试听安排？',
        })
        .catch(()=>{
          return false;
        })
        if (confirmRes) {
          this.showLoading();
          let res = await this.$api.auditionCancel({ studentId, courseArrangeId, priceItemId, campusId});
          if (res.code === 200) {
            this.$toast.success('取消试听成功。');
            item.status = 3;
            app.vue.$emit("refresh-communicate-list") 
          }
        }

      } catch (err) {
        console.error("取消试听出错", err);
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.mixied-communicate{
  padding: 0 0 calc(var(--gap) * 55) calc(var(--gap) * 4);
  position: relative;
  overflow: hidden;
  &::before{
    content: "";
    left: 0;
    right: 0;
    display: block;
    position: absolute;
    height: calc(var(--w) * 90);
    background: linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%);
  }
  .intention-communicate-item {
    position: relative;
    padding: 0 0 0 calc(var(--gap) * 16);
    border: 1px solid transparent;
    color: var(--g6);

    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: calc(var(--w) * 24);
      bottom: 0;
      width: 1px;
      background-color: var(--g4); 
    }
    &:last-child:not(:first-child) {
      &::before{
        display: none;
      }
    }
    .circular-point {
      position: absolute;
      top: calc(var(--gap) * 4);
      left: 0;
      width: calc(var(--w) * 10);
      height: calc(var(--w) * 10);
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: var(--g4);
      transform: translate(-50%, 0);
      border-radius: 50%;
      >i{
        font-size:var(--fs-sm);
        color: var(--white);
        transform: scale(0.9);
      }
      &.active{        
        background-color: var(--c4);
      }
      &.audition{
        background-color: var(--c2);
      }
    }
    .title {
      //   margin: 0 0 calc(var(--gap) * 8);
      margin-bottom: calc(var(--gap) * 8);
      margin-left: calc(var(--gap) * 4);
      font-size: var(--fs-sm);
      line-height: var(--lh-sm);
      .next-class {
        padding-left: calc(var(--gap) * 4);
        color: var(--c1);
      }
    }
    &:first-child{
      margin-top: calc(var(--gap) * 12);
    }
    &:last-child{
      &::before{
        display: none;
      }

    }
    &:first-child{
      .circular-point{        
        background-color: var(--c1);
      }
    }
  }
  .title + .intention-communicate-item {
    &:last-child{
      &::before{
        display: block;
      }
      .circular-point{        
        background-color: var(--c1);
      }
    }
  }
  .log-item{
    margin: calc(var(--gap) * 16) 0;
    .types-line{
      color: var(--g8);
    }
    .log-content {
      margin: calc(var(--gap) * 4) 0 calc(var(--gap) * 28);
      padding: calc(var(--gap) * 12);
      border-radius: var(--radius-sm);
      background-color: var(--g1);
      .line{
        display: flex;
        .content{
          flex: 1;
        }
        .label{
          white-space: nowrap;
          flex-shrink: 0;
        }
      }
      .tag.primary{
        color: var(--g6);
        border: unset;
        &:not(:last-child) {
          margin: 0;
          padding: 0;
          &::after{
            content: " · ";
            font-weight: var(--bold);
          }
        }
      }
    }
    .communicate-item{
      .content-nav .content{
        display: flex;
        >div{
          padding: 0;
          flex: 1;
        }
        i{
          font-size: var(--fs-lg);
          line-height: var(--lh-lg);
        }
        
        ::v-deep div.text{
          font-size:var(--fs-md);
          line-height:var(--lh-md);
        }
      }
    }
    .audition-item{
      overflow: hidden;
      padding: calc(var(--gap) * 12) 0 0;
      >div{        
        padding: 0 calc(var(--gap) * 12);
      }
      >div.line:last-child{
        margin-bottom: calc(var(--gap) * 12);
      }
      .tag{
        display: inline;
        white-space: nowrap;
      }
      .footer{
        margin-top: calc(var(--gap) * 10);
        display: flex;
        height: calc(var(--w) * 40);
        align-items: center;
        justify-content: center;
        color:var(--c1);
        font-size:var(--fs-sm);
        line-height:var(--lh-sm);
        font-weight: var(--bold);
        border-top: 1px solid var(--g3);
      }
    }
    .con {
      margin-top: calc(var(--gap) * 8);
      &:first-child {
        margin-top: 0;
      }
      .point {
        color: var(--g8);
      }
 
    }
    .tag {
      padding: 0 calc(var(--gap) * 4);
      display: inline-block;
      color: var(--g5);
      font-size:var(--fs-sm);
      
      color: var(--c1);
      border-radius: 2px;
      border: 1px solid var(--c1);
      &:not(:last-child){
        margin-right: calc(var(--gap) * 8);
      }
    }
  }
  .communicate-popover{
    
    height: calc(var(--w) * 18);
    &.popover-item{
      margin: 0 calc(var(--gap) * 12);
      width: calc(var(--w) * 96);
      height: calc(var(--w) * 44);
      font-size:var(--fs-md);
      font-weight: 400;
      line-height: 44px;
      text-align: center;
      color: var(--g8);
      cursor: pointer;
    }
  }
}
</style>